import React, { useCallback, useEffect, useState } from "react"
import styles from "./tour.module.css"
import Joyride, {STATUS} from "react-joyride"
import { useDispatch, useSelector } from "react-redux"
import { prop as p } from "ramda"
import { useMediaQuery } from 'react-responsive';
import { runTour, temp_country, temp_indicator, toggle_legend, toggle_panel } from "../store/load_data"

export const Tour = () => {
  const isMobile = useMediaQuery({ maxWidth: 720 });
  const country = useSelector(p("country"));
  const run = useSelector(p("run_tour"));
  const countries = useSelector(p("countries"));
  const indicator = useSelector(p("bubble"));
  const panel_open = useSelector(p("panel_open"));
  const [is_temp,set_temp] = useState({});
  const dispatch = useDispatch();
  const steps = [
      {target: "body",disableBeacon:true, placement:"center", disableOverlay:true, content: "Quick tour of the tool to get you started, just click next. The aim of the country profiles application is to serve as a data discovery tool for the Eurostudent database. The tool is not supposed to evaluate how good the country is doing in comparison to others, but merely highlight differences and link it easily to the corresponding tabels in the database."},
      {target:"#country-select",styles: {spotlight: {marginTop: '1.25rem',transform: 'scaleY(0.7)',padding:0}},disableBeacon:false, content: `Select a country you wish to compare.${!is_temp.country ? `You currently have chosen ${countries[country]}.` : " Let's use Estonia for example."}`},
      {target:"#comparison-select",content: (<>
      <p>Adjust the list of countries you want to compare your selected country to.</p>
      <p className={styles.tip_comment}>Some indicators measure difference from comparison countries in standard deviations from the comparison group average. When choosing only one comparison country, standard deviation becomes 0, (single country's value doesn't deviate from itself) and therefore the difference cannot be calculated. We <b>recommend choosing at least 2 comparison countries besides the country itself</b> so that all indicators can be calculated.</p>
      </>)},
      {target:".placeholder",disableBeacon: false,placement:"right-start",content: "The application calculates the difference on a 0.00-1.00 scale,which is divided into 5 equal parts (5 levels of difference). The legend can be opened and close by either clicking on the Scale button or the legend itself."},
      {target:".bubble",disableBeacon: false,content: "To see more information about the indicator, click on the bubble."},
      {target:".subindicators",placement:"top-end",disableBeacon: false, content: "Some indicators consist of subindicators. An illustrative graph of difference form comparison is shown for each subindicator that the country has."},
      {target:".panes_placeholder",disableBeacon: false, placement:"top-end", content: 'To see more information about the currently opened subindicator, click on the buttons below the visual: "show graph (active)", "information", "response rates", "calculation steps" and "link to database". In some cases selected indicator is based on more than 1 database links, so the last button doesn\'t take you directly to database, but shows all possible database links inside the information pane.'},
  ]
  const tourCallback = useCallback((data,a,b) => {
    const { status, index,type } = data;
    if (index === 1) {
      if (country === undefined) {
        dispatch(temp_country("EE"));
        set_temp({...is_temp,country:1})
      }
      set_temp({...is_temp,indicator:JSON.parse(JSON.stringify(indicator)),panel_open: panel_open});
      dispatch(toggle_panel(false));
    }
    if (index === 3 && type === "step:before") {
      dispatch(toggle_legend())
    }
    if (index === 3 && type === "step:after") {
      dispatch(toggle_legend())
    }
    if (index === 5 && type === "step:before") {  
      dispatch(toggle_panel(true));
      dispatch(temp_indicator("15"))
      }
    if (index === 6 && type === "step:before") {
      dispatch(temp_indicator("12"))
      dispatch(temp_indicator("12"))
    }
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      if(is_temp.country) dispatch(temp_country(undefined));
      if(is_temp.indicator) dispatch(temp_indicator(is_temp.indicator));
      if(!is_temp.panel_open) dispatch(toggle_panel(false));
      dispatch(runTour(0));
      set_temp({});
    }
  }, [country, indicator, is_temp, set_temp, dispatch]);

    return <Joyride 
        showSkipButton
        continuous
        callback={tourCallback}
        run={run}
        showProgress
        steps={steps}
        spotlightPadding={0}
        styles={{
            options: {
              arrowColor: "transparent",
              backgroundColor:" #F4F9FF",
              primaryColor: "#2C70D4",
              textColor: '#2C70D4',
            },
            tooltip: {
              boxShadow: "0.1rem 0.2rem 0.25rem rgba(44, 111, 212, 0.25), 0rem 0rem 0.2rem rgba(44, 111, 212, 0.5)"
            },
            spotlight: {
              borderRadius:"1rem"
            },
            overlay: {
              paddingBottom: '4.8rem', 
              position: "fixed",
              bottom: 0,
              height: "100vh",
              boxSizing: "border-box"
            },
          }} />
} 